import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: `${API}/api`,
  headers: {
    'Accept': 'application/json',
    'Cache-Control': 'no-cache, no-store',
    'Pragma': 'no-cache'
  }
});

// Add auth token and cache-busting to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('agm_access_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  // Cache-busting for GET requests
  if (!config.method || config.method === 'get') {
    config.params = { ...config.params, _t: Date.now() };
  }
  // Set Content-Type only for non-GET if not already explicitly set (e.g. multipart/form-data)
  if (config.method && config.method !== 'get') {
    if (!config.headers['Content-Type'] || config.headers['Content-Type'] === 'application/json') {
      // Don't override if caller set multipart/form-data (file upload)
      const isFormData = config.data instanceof FormData;
      if (isFormData) {
        delete config.headers['Content-Type'];
      } else {
        config.headers['Content-Type'] = 'application/json';
      }
    }
  }
  return config;
});

// Error formatter
export function formatApiError(detail) {
  if (detail == null) return "Hiba történt. Kérjük próbálja újra.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
